export enum MessageType {
  SendGrid = 'SendGrid',
  APNS = 'APNS',
  MessageBird = 'MessageBird',
  Selligent = 'Selligent',
  SMTP = 'SMTP',
}

export const EmailMessageTypes = new Set([MessageType.SendGrid, MessageType.SMTP]);
export const SmsMessageTypes = new Set([MessageType.MessageBird]);

export enum MessageLogStatus {
  Blocked = 'blocked',
  Bounce = 'bounce',
  Failure = 'failure',
  Invalid = 'invalid',
  SendX = '_send',
  Send = 'send',
  Sent = 'sent',
  Delivered = 'delivered',
  Processing = 'processing',

  // delivery event types
  Processed = 'processed',
  Deferred = 'deferred',
  Buffered = 'buffered',
  Dropped = 'dropped',
  Expired = 'expired',
  DeliveryFailed = 'delivery_failed',

  // unknown
  Unknown = 'unknown',
}
